module.exports = __webpack_public_path__ + "static/media/techimage.996ea8ec.jpg";